import { useParams } from "react-router-dom";
import SingleTrick from "../components/SingleTrick";

export default function OneTrickPage(props) {
  let { trickId } = useParams();
  return <SingleTrick id={trickId} />;
}
